import { useContext, type FC } from "react";

import { canViewSupersetDashboards } from "@thalamos/aspire-common";

import { DashboardPage } from "../DashboardPage.js";
import type { DefaultPageProps } from "../defaultProps.js";
import { DashboardLandingPage } from "./DashboardLandingPage.js";
import { LoggedInUserContext } from "~/Contexts.js";

export const DashboardHomePage: FC<DefaultPageProps> = (props) => {
  const userContext = useContext(LoggedInUserContext);
  const user = userContext?.user;

  if (!canViewSupersetDashboards(user)) {
    return <DashboardPage {...props} />;
  }

  return <DashboardLandingPage />;
};
